import { olapicSSOClient } from 'olapic-sso-client';

class AppSession {
  constructor(
    $location,
    appAPI,
    appConfiguration,
    appErrorHandler,
    appEvents,
    APP_EVENTS,
  ) {
    'ngInject';

    this.$location = $location;
    this.appAPI = appAPI;
    this.appConfiguration = appConfiguration;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.APP_EVENTS = APP_EVENTS;

    this._configureSSOClient();
  }
  isAuthenticated() {
    return olapicSSOClient.isAuthenticated();
  }
  load() {
    return this.isAuthenticated();
  }
  authenticate(sessionExpired) {
    olapicSSOClient.setConfig({
      callback: this.$location.absUrl(),
    });

    const authenticationReason = sessionExpired ?
      olapicSSOClient.AUTHENTICATION_REASONS.expiration :
      null;

    return olapicSSOClient.authenticate(authenticationReason);
  }
  signout() {
    return olapicSSOClient.signout();
  }
  getSession() {
    return olapicSSOClient.getSession();
  }
  onSessionLoaded(fn) {
    return olapicSSOClient.on(olapicSSOClient.EVENTS.session.load, fn);
  }
  onSessionChange(fn) {
    return olapicSSOClient.on(olapicSSOClient.EVENTS.session.change, fn);
  }
  onSessionCreated(fn) {
    return olapicSSOClient.on(olapicSSOClient.EVENTS.session.creationSuccess, fn);
  }
  onSessionCreationStarts(fn) {
    return olapicSSOClient.on(olapicSSOClient.EVENTS.session.creationStart, fn);
  }
  onSessionCreationFinishes(fn) {
    return olapicSSOClient.on(olapicSSOClient.EVENTS.session.creationFinish, fn);
  }
  onSessionInterrupted(fn) {
    return olapicSSOClient.once(olapicSSOClient.EVENTS.session.interrupted, fn);
  }
  onSessionEnd(fn) {
    return olapicSSOClient.once(olapicSSOClient.EVENTS.session.end, fn);
  }
  onSessionUnauthorizedToken(fn) {
    return this.appEvents.once(this.APP_EVENTS.session.unauthorized, fn);
  }
  updateSettings(
    name,
    email,
    currentPassword = '',
    newPassword = '',
    confirmNewPassword = '',
  ) {
    let result;
    const session = this.getSession();
    if (this.isAuthenticated()) {
      result = this.appAPI.update(
        name,
        email,
        session.email,
        currentPassword,
        newPassword,
        confirmNewPassword,
      )
      .then(() => {
        this._updateSession({ name, email });
      });
    } else {
      result = this.$q.reject(new Error('The user needs to be logged in'));
    }

    return result;
  }
  rememberPassword(email, referer) {
    let result;
    if (this.isAuthenticated()) {
      result = this.$q.reject(new Error('The user is already logged in'));
    } else {
      result = this.appAPI.rememberPassword(email, referer);
    }

    return result;
  }
  referrer(code, ref) {
    return this.appAPI.referrer(code, ref);
  }
  resetPassword(code, newPassword, confirmNewPassword) {
    let result;
    if (this.isAuthenticated()) {
      result = this.$q.reject(new Error('The user is already logged in'));
    } else {
      result = this.appAPI.resetPassword(
        code,
        newPassword,
        confirmNewPassword,
      );
    }

    return result;
  }
  _configureSSOClient() {
    const { sso } = this.appConfiguration;
    olapicSSOClient.setClientConfig({
      api: {
        url: sso.url,
      },
    });
    olapicSSOClient.setConfig(sso.settings);
  }
  _updateSession(changes) {
    const supportedChanges = ['name', 'email'];
    const currentUser = this.getSession().user;
    const hasChanges = supportedChanges
    .some((property) => currentUser[property] !== changes[property]);

    if (hasChanges) {
      olapicSSOClient.updateUserInformation(changes);
    }
  }
}

export default AppSession;
